/**
 * Environment configuration using Vite's official env patterns
 * https://vite.dev/guide/env-and-mode
 */

// Helper function to parse boolean environment variables
const parseBoolean = (value: string | undefined): boolean => {
  if (value === undefined) return false
  return value.toLowerCase() === 'true'
}

// Helper function to parse number environment variables
const parseNumber = (value: string | undefined, defaultValue: number = 0): number => {
  if (value === undefined) return defaultValue
  const parsed = Number(value)
  return Number.isNaN(parsed) ? defaultValue : parsed
}

export default {
  // Vite built-in environment variables
  MODE: import.meta.env.MODE,

  // Application-specific environment variables
  CYPRESS: parseBoolean(import.meta.env.VITE_CYPRESS),

  // Sentry configuration
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_TRACES_SAMPLE_RATE: parseNumber(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
  SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE,

  // Grafana configuration
  GRAFANA_TELEMETRY_ENABLED: parseBoolean(import.meta.env.VITE_GRAFANA_TELEMETRY_ENABLED),
  GRAFANA_URL: import.meta.env.VITE_GRAFANA_URL,

  // Auth0 configuration
  AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
  AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,

  // API endpoints
  FTG_API_URL: import.meta.env.VITE_FTG_API_URL,
  FTG_BFF_URL: import.meta.env.VITE_FTG_BFF_URL,
  FTG_WS_URL: import.meta.env.VITE_FTG_WS_URL,

  // Application features
  IS_STORYBOOK: parseBoolean(import.meta.env.VITE_IS_STORYBOOK),
  PENDO_API_KEY: import.meta.env.VITE_PENDO_API_KEY,
  PENDO_ENABLED: parseBoolean(import.meta.env.VITE_PENDO_ENABLED),
  DESMOS_API_KEY: import.meta.env.VITE_DESMOS_API_KEY,

  // Environment identification
  ENV: import.meta.env.VITE_ENV || import.meta.env.MODE,

  // Development features
  DISPLAY_DEBUGGER: parseBoolean(import.meta.env.VITE_DISPLAY_DEBUGGER),
} as const
